export default __webpack_public_path__ + "static/votre_police-1b66592acb7761bb176c6b75f7302fce.png";